var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#5f6368",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-120q-42 0-71-29t-29-71 29-71 71-29 71 29 29 71-29 71-71 29M254-346l-84-86q59-59 138.5-93.5T480-560t171.5 35T790-430l-84 84q-44-44-102-69t-124-25-124 25-102 69M84-516 0-600q92-94 215-147t265-53 265 53 215 147l-84 84q-77-77-178.5-120.5T480-680t-217.5 43.5T84-516"
  })));
};
export default SvgWifi;